export enum SubscriptionState {
  Subscribe = 'subscribe',
  Unsubscribe = 'unsubscribe',
}
